import _ from 'lodash'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Returns whether the calendar period selector should be displayed
 * for an item.
 *
 * Based on the item's section, type or subtype.
 * Default is to return true if no args are supplied
 * @param {Object} context
 * @param {String} [context.section] e.g. 'reports' or 'files'
 * @param {String} [context.type] e.g. 'report' or 'folder'
 * @param {String} [context.subtype] e.g. 'sql-console'
 * @returns {boolean} whether the period selector should be displayed
 */
function periodSelectorDisplayed(context) {

	// if no context was supplied, the period selector should be displayed
	if (_.isEmpty(context)) {
		return true
	}

	const {section, type, subtype} = unwrapModel(context)
	// sections that don't need a period selector: datasets, files, and initiatives
	if (section === 'files' || section === 'datasets' || section === 'initiatives') {
		return false
	}

	if (section === 'reports') {
		// report subtypes that don't use calendar periods: sql console, annual metric data, initiative report
		if (subtype === 'sql-console' || subtype === 'annual-metric-data' || subtype === 'initiative-report') {
			return false
		}
	}

	// types that don't need a period selector: folder
	if (type === 'folder') {
		return false
	}

	return true
}

export default periodSelectorDisplayed
periodSelectorDisplayed.__filename__ = 'components/period-selector-displayed.js'
